<ion-header>
  <ion-toolbar color="primary">
    @if (isUserAuthenticated) {
      <ion-buttons slot="start">
        <ion-back-button [text]="null" defaultHref="/dashboard"></ion-back-button>
      </ion-buttons>
    }
    <ion-title>CARO</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="page-header-card">
    <div class="header-title">
      <ion-icon name="calendar-outline"></ion-icon>
      <span>Repetitie {{ isEditMode ? 'Bewerken' : 'Invullen' }}</span>
    </div>
    @if (rehearsalRequest.performance != null) {
      <div class="header-date">
        <span class="date">{{ rehearsalRequest.performance.datetime | readableDateTime: 'date' }}</span>
        <span class="time">{{ rehearsalRequest.performance.datetime | readableDateTime: 'time' }}</span>
      </div>
    }
  </div>

  @if (rehearsal && (!hasBeenSaved || isUserAuthenticated)) {
    @if (!hideForm) {
      @if (rehearsalRequest.performance != null) {
        <app-rehearsal-form
          [availableScenes]="items"
          [initialData]="rehearsal"
          [isEditMode]="isEditMode"
          [isSaving]="isSaving"
          [enableSceneReordering]="true"
          [showSummary]="true"
          (save)="onFormSave($event)"
          />
        }
      }
    } @else {
      @if (isLoading) {
        <ion-spinner name="crescent" color="primary" />
      } @else {
        @if (!rehearsal) {
          Geen repetitie gevonden.
        }
        @if (hasBeenSaved && !isUserAuthenticated) {
          Repetitie succesvol {{ isEditMode ? 'bijgewerkt' : 'opgeslagen' }}. <br>Je kunt deze pagina nu sluiten.
          <br><br>
          <app-rehearsal-summary [rehearsal]="rehearsal" />
        }
      }
    }

  </ion-content>
